// extracted by mini-css-extract-plugin
module.exports = {"form":"newFolderModal_form__KX6AY","controls":"newFolderModal_controls__cdTv0","fullWidth":"newFolderModal_fullWidth__49QHk"};